<!-- Settings content rendered via router-outlet in AppLayoutComponent's sidebar child area -->
<!-- Sidebar menu is managed via SidebarViewService (pushed in setUpSidebar, popped in ngOnDestroy) -->
@if(!setupSidebarDone) {
<div class="flex justify-center items-center h-full w-full">
    <div class="flex flex-col gap-3 justify-center items-center">
        <div class="flex flex-row gap-3 justify-center items-center">
            <span class="font-semibold text-xl">Loading settings</span>
            <i class="pi pi-spin pi-spinner text-5xl"></i>
        </div>
        <span class="font-semibold text-xl text-neutral-400">Please wait while we load the settings...</span>
    </div>
</div>
} @else {
<router-outlet></router-outlet>
}
<app-excel-upload-dialog [visible]="uploadExcelDialogVisible" (downloadSampleExcelClicked)="downloadSampleExcel()"
    (downloadExistingExcelClicked)="downloadExistingExcel()" (onDialogClose)="onExcelDialogClose()"
    (onExcelUpload)="uploadExcel($event)" [downloadExistingExcelData]="true"
    [showUploadOptions]="true"></app-excel-upload-dialog>

<p-confirmDialog #cd>
    <ng-template pTemplate="headless" let-message>
        <div class="flex flex-col align-items-center p-5 surface-overlay border-round w-[30rem]">
            <span class="font-bold text-2xl block mb-2 mt-4">
                {{ message.header }}
            </span>
            <p class="mb-0" [innerHTML]="message.message"></p>
            <div class="flex justify-end items-end float-left gap-2 mt-4">
                <app-button label="Yes" (clicked)="handleConfirmAccept(message)" variant="filled" severity="primary"
                    icon="pi pi-check" />
                <app-button label="No" (clicked)="cd.hide()" variant="outlined" severity="danger" icon="pi pi-times" />
            </div>
        </div>
    </ng-template>
</p-confirmDialog>
